/** Query keys for opening Full Compare from Inventory Quick Compare (see PAGE_COMPARISON.md). */
export const FULL_COMPARE_YOUR_QP = 'fullCompareYour';
export const FULL_COMPARE_COMPETITOR_QP = 'fullCompareCompetitor';

export interface FullComparePrefill {
  yourPageUrl: string;
  competitorPageUrl: string;
}

function normalizeUrlCandidate(raw: string | null | undefined): string | null {
  const t = (raw || '').trim();
  if (!t) return null;
  try {
    const u = new URL(t);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
    return u.href;
  } catch {
    try {
      const u = new URL(/^https?:\/\//i.test(t) ? t : `https://${t}`);
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
      return u.href;
    } catch {
      return null;
    }
  }
}

/**
 * Reads Full Compare pre-fill from query params. Ignores when `executionId` is set (persisted comparison wins).
 * Both query params must be present; otherwise returns null.
 */
export function parseFullComparePrefillFromQuery(
  query: { get(name: string): string | null },
  executionId: string | null | undefined
): FullComparePrefill | null {
  if (executionId) return null;

  const rawY = query.get(FULL_COMPARE_YOUR_QP);
  const rawC = query.get(FULL_COMPARE_COMPETITOR_QP);
  const hasY = !!(rawY && rawY.trim());
  const hasC = !!(rawC && rawC.trim());
  if (hasY !== hasC) return null;
  if (!hasY) return null;

  const yourPageUrl = normalizeUrlCandidate(rawY);
  const competitorPageUrl = normalizeUrlCandidate(rawC);
  if (!yourPageUrl || !competitorPageUrl) return null;
  return { yourPageUrl, competitorPageUrl };
}
